<template>

    <section id="about">

        <div class="topbanner">
            <div class="headline">
                <h1 v-bind:class="{ 'blur': blurheadline}">Disrupting the <br>digital brandscape.</h1>
                <!-- <p class="subhead" v-bind:class="{ 'blur': blurheadline}">Disrupting the digital brandscape for over 30
                    years.</p> -->
            </div>


          <figcaption class="page-header-description topbottom">ABOUT</figcaption>

            <div id="topheader">
                <vue-p5 @sketch="sketch"></vue-p5>
            </div>
            <div class="overlay"></div>
        </div>


        <b-row class="aboutus">
            <!-- <b-img fluid :src="require(`../assets/images/sinewave.svg`)" alt="Sine Wave"></b-img> -->

            <b-container>
                <b-row>
                    <b-col data-aos="fade-right" col cols="12">
                        <h2>Original and Authentic</h2>
                    </b-col>
                    <b-col data-aos="fade-right" col md="6" cols="12">
                        <p>Having 35 years under our belt in the ad game is a rarity these days – but there’s a reason
                            we do. At our core we deliver digital content with substance. We regard our clients as
                            partners. We do our absolute best to nurture client relationships for the long haul through
                            service, integrity, and results. From our humble beginnings as a small shop making big waves
                            in traditional advertising, we’ve grown and evolved into the full-service digital agency we are today.</p>
                    </b-col>
                    <b-col data-aos="fade-left" col md="4" cols="12">
                        <p>We invite you to do what many of our valued long-term clients have done; Reach out to us to discuss your marketing goals and <span class="orange">let's start something great together.</span></p>
                                 <b-img class="thirtyyears" fluid :src="require(`../assets/images/35year.svg`)" alt="35 Years"></b-img>
                    </b-col>
                </b-row>
            </b-container>

        </b-row>

    
        <b-row class="goals">
            <b-container>
                <b-row>
                    <b-col data-aos="fade-right" col cols="12">
                        <h2>Calculated Creative</h2>
                    </b-col>
                    <b-col data-aos="fade-right" col md="5" cols="12">
                        <p>Before the creative process begins, we explore who you are, the goals you’d like to achieve,
                            who your audience is, and the most effective strategies to reach them. We believe strongly in
                            the creative brief to understand your story, your pain points, and finally, what your
                            benchmarks for success look like. With this information in hand, our marketing team develops
                            personas representative of your particular user segments and maps out an actionable plan to
                            craft a message that they receive and that resonates with them.</p>
                    </b-col>
                    <b-col data-aos="fade-left" col md="5" cols="12">
                        <p>We rely on KPIs to measure success in terms of engagement and how that translates into a
                            return on your investment. You can expect full marketing support from beginning to launch to
                            measurement and analysis on all our campaigns and programs. Our strategic thinking combined with effective tactics ensure you get the most efficiency and
                            bang for your marketing buck.</p>
                    </b-col>
                </b-row>
            </b-container>
        </b-row>


        <b-row class="proprocess">
            <b-container>
                <b-row>
                    <b-col data-aos="fade-right" data-aos-offset="500" col lg="12" cols="12" class="copy">
                        <h2>The Power of Process.</h2>
                        <p>Like a path, without a process it’s easy to get lost. We keep our projects on a
                            <span>start-to-finish</span> track that the entire team is on board with to ensure
                            efficiency, quality, and accountability. </p>
                    </b-col>
                    <b-col data-aos="fade-left" data-aos-offset="500" col lg="12" cols="12">

                        <!-- <BrantonBInteractiveAnimation :inview="inview" v-in-viewport.once></BrantonBInteractiveAnimation> -->

                        <b-row class="branton-b-container">
                            <b-col col cols="6" md="3">
                              <span class="number">1</span>
                              <p class="processbox">Project Kickoff</p>
                            </b-col>

                            <b-col col cols="6" md="3">
                                <span class="number">2</span>
                              <p class="processbox">Creative & Technical Exploration</p>
                            </b-col>

                            <b-col col cols="6" md="3">
                                <span class="number">3</span>
                              <p class="processbox">Analyze & Examine</p>
                            </b-col>

                            <b-col col cols="6" md="3">
                                <span class="number">4</span>
                              <p class="processbox">Creative Definition & Direction</p>
                            </b-col>

                            <b-col col cols="6" md="3">
                                <span class="number">5</span>
                              <p class="processbox">Conceptual Design</p>
                            </b-col>

                            <b-col col cols="6" md="3">
                                <span class="number">6</span>
                              <p class="processbox">Refined Design</p>
                            </b-col>

                            <b-col col cols="6" md="3">
                                <span class="number">7</span>
                              <p class="processbox">Launch</p>
                            </b-col>

                            <b-col col cols="6" md="3">
                                <span class="number">8</span>
                              <p class="processbox">Measure & Monitor</p>
                            </b-col>
                            </b-row>

                    </b-col>
                </b-row>
            </b-container>
        </b-row>


        <b-row class="dna">
            <b-container>
                <b-row>
                    <!-- <b-col data-aos="fade-up" col cols="12">
                        <h3>Digital content is in our DNA.</h3>
                    </b-col>
                    <b-col data-aos="fade-up" col cols="12">
                        <p>We are built for playing in digital spaces.</p>
                    </b-col> -->
                    <b-col  col cols="12">

                        <!-- <picture>
                        <source media="(min-width: 769px)" :srcset="require(`../assets/images/DNA-Horz.svg`)">
                        <b-img fluid :src="require(`../assets/images/DNA-Vert.svg`)" alt="DNA"></b-img>
                        </picture> -->

                        <dnastrand id="dna-desktop" :inview="inview" v-in-viewport.once></dnastrand> 
                        <!-- <b-img fluid :src="require(`../assets/images/dna.svg`)" alt="DNA"></b-img> -->
                    </b-col>

                    <b-col  col cols="12">
                    <dnamobile id="dna-mobile"  :inview="inview" v-in-viewport.once></dnamobile> 
                    </b-col>
                </b-row>
            </b-container>
        </b-row>



        <!-- <b-row class="culture">

            <b-col col cols="12" lg="5">
                <b-row class="inside left">
                    <b-col col cols="12"></b-col>
                    <b-col col cols="5" md="6"></b-col>
                    <b-col col cols="7" md="6"></b-col>
                </b-row>
            </b-col>

            <b-col col cols="12" lg="7" class="inside right">
                <b-row>



                    <b-col col cols="4"></b-col>
                    <b-col col cols="12" md="4" offset-md="-4">
                        <b-row class="moreinside">
                            <b-col col cols="6" md="12">


                            </b-col>
                            <b-col col cols="6" md="12"></b-col>
                        </b-row>
                    </b-col>
                    <b-col col cols="6" md="4"></b-col>


                    <b-col col cols="6" md="4"></b-col>
                    <b-col col cols="12" md="8"></b-col>
                </b-row>
            </b-col>



        </b-row> -->


    </section>

</template>

<script>
    import VueP5 from "vue-p5";
    // import BrantonBInteractiveAnimation from '@/views/supports/BInteractiveAnimation';
      import dnastrand from '@/views/supports/dnastrand';
      import dnamobile from '@/views/supports/dnamobile';
    import AOS from 'aos';
    import 'aos/dist/aos.css';
    export default {
        metaInfo: {
            titleTemplate: 'Learn About Branton — A Creative Design Agency',
            meta: [{
                name: "About Us",
                content: "Branton, a team of explorers, creators and disruptors, provides creative solutions for industries across Canada. Let’s start something great together. "
            }]
        },
        components: {
            "vue-p5": VueP5,
            dnastrand,
            dnamobile
        },
        data() {
            return {
                scrolled: false,
                ready: false,
                blurheadline: false,
                inview: false
            };
        },
        mounted() {

               this.$gtag.pageview({
        page_path: '/about',
      })

            this.ready = true;
                   AOS.init();
            window.addEventListener("load", function() {
                AOS.refresh();
            });

            let vm = this;
            const observer = new MutationObserver((mutation) => {
            if(mutation[0].target.classList.contains('in-viewport')){
            vm.inview = true;
            return observer.disconnect();
            }
            });
            observer.observe(document.querySelector('.branton-b-container'), {
            attributes: true,
            attributeOldValue: true,
            attributeFilter: ['class']
            });

        },
        methods: {

 
           handleScroll() {
                if (window.scrollY > 400) {
                    this.blurheadline = true;
                } else {
                    this.blurheadline = false;
                }

            },
            sketch(p5) {
                let pos, colors;
                const moveSpeed = 0.3;
                const moveScale = 1500;
                p5.setup = () => {
                    var canvas = p5.createCanvas(p5.windowWidth, p5.windowHeight);
                    canvas.parent('topheader');
                    p5.background(74, 79, 85);
                    p5.noStroke();
                    colors = [p5.color("#FFB71A"), p5.color("#CC9723"), p5.color("#A27411"), p5.color("#CC9723"), p5
                        .color("#6A5830")
                    ];
                    pos = [];
                    for (let i = 0; i < 500; i++) {
                        pos.push({
                            x: p5.random(p5.width),
                            y: p5.random(p5.height),
                            c: colors[p5.floor(p5.random(colors.length))]
                        });
                    }
                }
                p5.draw = () => {
                    for (let i = 0; i < pos.length; i++) {
                        let angle = p5.noise(pos[i].x / moveScale, pos[i].y / moveScale) * p5.TWO_PI * moveScale;
                        pos[i].x += p5.cos(angle) * moveSpeed;
                        pos[i].y += p5.sin(angle) * moveSpeed;
                        p5.fill(pos[i].c);
                        p5.ellipse(pos[i].x, pos[i].y, 2, 2);
                        if (pos[i].x > p5.width || pos[i].x < 0 || pos[i].y > p5.height || pos[i].y < 0 || p5
                            .random(1) < 0.001) {
                            pos[i].x = p5.random(p5.width);
                            pos[i].y = p5.random(p5.height);
                        }
                    }
                }
                p5.windowResized = () => {
                    var canvasDiv = document.getElementById('topheader');
                    var height = canvasDiv.offsetHeight;
                    p5.resizeCanvas(p5.windowWidth, height);
                    p5.background(67, 67, 67);
                    p5.noStroke();
                    colors = [p5.color("#FFB71A"), p5.color("#CC9723"), p5.color("#A27411"), p5.color("#CC9723"), p5
                        .color("#6A5830")
                    ];
                    pos = [];
                    for (let i = 0; i < 500; i++) {
                        pos.push({
                            x: p5.random(p5.width),
                            y: p5.random(p5.height),
                            c: colors[p5.floor(p5.random(colors.length))]
                        });
                    }
                }
            }
        },
        created() {
            window.addEventListener('scroll', this.handleScroll);
        },
        destroyed() {
            window.removeEventListener('scroll', this.handleScroll);
        }
    }
</script>


<style lang="scss">
    @import '@/assets/css/about.scss';


    span.number {
    font-size: 10rem;
    color: transparent;
    -webkit-text-stroke-width: 3px;
    -webkit-text-stroke-color: #ffb71b;
    font-weight: 700;
    text-align: center;
    display: block;
    }
    p.processbox {
    background: #ffb71b;
    color:black;
    min-height: 80px;
    padding: 0 20px;
    text-align: center;
    display: flex;
    position: absolute;
    width: 88%;
    bottom: -2rem;
    align-items: center;
    justify-content: center;
}


#dna-desktop {
  display:none;
}
@include media-breakpoint-up(lg) {
  #dna-mobile{
  display:none;
}
#dna-desktop {
  display:block;
}
}

</style>